/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Checkpoint_EditInputs */



/**
* | output |
* | --- |
* | "Edit & restore" |
*
* @param {Assistant_Checkpoint_EditInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_checkpoint_edit = /** @type {((inputs?: Assistant_Checkpoint_EditInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Checkpoint_EditInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier et restaurer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bearbeiten und wiederherstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica e ripristina")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактировать и восстанавливать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editar y restaurar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑和恢复")
	if (locale === "ja") return /** @type {LocalizedString} */ ("編集と復元")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपादित करें और पुनर्स्थापित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editar e restaurar")
	return /** @type {LocalizedString} */ ("Edit & restore")
});